// src/components/About.js

import { GiSwissArmyKnife } from 'react-icons/gi'; 
import React from 'react';
import { BsFillPatchCheckFill, BsCurrencyEuro, BsFillClockFill, BsHandThumbsUpFill } from 'react-icons/bs';

const features = [
    {
        icon: <BsFillPatchCheckFill />,
        title: "Professionnalisme & Expérience",
        description: "Un savoir-faire reconnu pour des prestations de qualité"
    },
    {
        icon: <BsFillClockFill />,
        title: "Proximité & Réactivité",
        description: "Votre artisan local sur Le Tampon, disponible et à votre écoute pour des interventions rapides dans la mesure du possible."
    },
    {
        icon: <GiSwissArmyKnife />,
        title: "Polyvalence",
        description: "Un seul artisan pour tous vos besoins en électricité, petits travaux ou accompagnement dans vos projets plus conséquents"
    },
    {
        icon: <BsCurrencyEuro />,
        title: "Prix Transparents",
        description: "Devis gratuit et détaillé sans surprise. Tarifs compétitifs d'autoentrepreneur."
    },
    {
        icon: <BsHandThumbsUpFill />,
        title: "Satisfaction Garantie",
        description: "Ma priorité est de vous fournir un travail soigné qui répond parfaitement à vos attentes."
    }
];

const About = () => {
    return (
        <section id="pourquoi" className="section">
            <div className="title-container">
                <h2 className="section-title">Pourquoi me Choisir</h2>
                <p className="section-subtitle">
                    L'excellence électrique et le savoir-faire pluridisciplinaire à votre service au Tampon
                </p>
            </div>
            <div className="features-grid">
                {features.map((feature, index) => (
                    <div className="feature-card" key={index}>
                        <div className="feature-icon">{feature.icon}</div>
                        <h3 className="feature-title">{feature.title}</h3>
                        <p className="feature-description">{feature.description}</p>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default About;